import React, { useState, useEffect } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import Icon from '../../components/icons';
// import ReactWordcloud from 'react-d3-cloud';
// import ReactWordcloud from 'react-wordcloud';
import WordCloud from "react-d3-cloud";
import { useStoreSelector, useAuthStatus, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { useTopicWordApi } from '../../store/api/hooks/topicwordApiHook';
import toast from 'react-hot-toast';
import moment from 'moment';
import Spinner from '../../components/iconSvgs/spinner';

const WordClouds: React.FC = () => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [wordData, setWordData] = useState<any[]>([]);
    const [totalcount, setTotalCount] = useState(0)

    const wordAPI = useTopicWordApi();
    const navigate = useNavigate();
    const branchDS = useStoreBrnDSSelector();

    useEffect(() => {
        const param = {
            'branch_id': branchDS?.branch_id,
            'page': 1, // Page is 1-based, adjust accordingly
            'page_size': 20
        };
        getWords(param);
    }, []);

    const getWords = (data: any) => {
        setOnSubmitLoading(true);
        try {
            setTimeout(() => {
                wordAPI.getWords(data, (msg: any, resp: any) => {
                    if (resp.data && Array.isArray(resp.data)) {
                        const formattedData = resp.data.map((item: any) => ({
                            text: item?.word || "", // Adjust this according to your API response
                            value: item?.mentions || 0, // Adjust this according to your API response
                        }));

                        setWordData(formattedData);
                        setTotalCount(resp.totalCount || 0); // Assuming the total count is in the response
                    }
                }, (err: any) => {
                    toast.error(err);
                });
                setOnSubmitLoading(false);
            }, 3000);
        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }

    };

    return (

        wordData.length > 0 ? (<div style={{ width: "500px", height: "500px" }} className='mobile-width-height-300'>
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            <WordCloud
                data={wordData}
                width={500}
                height={500}
                font="Roboto"
                fontSize={(d) => Math.log(d.value) * 20}
                rotate={(d) => (d.value % 2 === 0 ? 0 : 90)}
                padding={5}
            />

        </div>
        ) : (
            <div>No data available.</div>
        )

        // <ReactWordcloud words={words}
        //     options={options}
        // />

    );
};

export default WordClouds;